export function generateRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export const phoneRegex = /^(?:\+91[-\s]?|0)?[6-9]\d{9}$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const roundedInputBoxStyle = (height: string) => ({
    backgroundColor: 'white',
    borderRadius: '50px',
    border: 'none',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.25)',
    '& .MuiOutlinedInput-root': {
        borderRadius: '50px',
        height: height,

        paddingRight: '10px',
        display: 'flex',
        alignItems: 'center',
    },
});


export const getFileDetails = (filePath: string) => {
    const fullName = filePath.split('/').pop() ?? filePath;
    const parts = fullName.split('.');
    const extension = parts.length > 1 ? parts.pop()!.toLowerCase() : '';
    const name = parts.join('.');
    return { name, extension };
};

 const loginEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

 export function validateEmail(username: string): boolean {
    const trimmed = username.trim();
     if (!loginEmailRegex.test(trimmed)) {
        return false;
    }
    return true;
}